module.exports = __webpack_public_path__ + "img/vizual-skole.9dd890bc.png";